"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ViewAll = function (_a) {
    var onClickHandler = _a.onClickHandler;
    var t = (0, next_intl_1.useTranslations)('lottery');
    return (react_1.default.createElement("button", { className: styles_module_scss_1.default.button, onClick: onClickHandler }, t('viewAll')));
};
exports.default = ViewAll;
